import React, { Component, createRef } from 'react';
import { Container, Navbar, Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { LoginMenu } from './api-authorization/LoginMenu';
import '../css/NavMenu.css';
import { Col, Dropdown, Row } from 'react-bootstrap';
import "bootstrap-icons/font/bootstrap-icons.css";

export class NavMenu extends Component {
    static displayName = NavMenu.name;

    constructor(props) {
        super(props);

        this.refToToggleDropdownButton = createRef();

        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.showHideSidebar = this.showHideSidebar.bind(this);
        this.showHideDropdown = this.showHideDropdown.bind(this);

        this.state = {
            collapsed: true,
        };
    }

    toggleNavbar() {
        this.setState({
            collapsed: !this.state.collapsed,
        });
    }

    showHideSidebar() {
        if (this.props.onSidebarDisplayChange) {
            this.props.onSidebarDisplayChange();
        }
    }

    showHideDropdown() {
        const toggleBtn = this.refToToggleDropdownButton.current;
        if (toggleBtn) {
            toggleBtn.click();
        }
    }

    render() {
        const isSidebarVisible = this.props.isSidebarVisible;
        const toggleBtnClass = "";

        return (
            <nav>
                <Dropdown className="position-relative">
                    <div
                        className="btn lh-1 d-flex flex-row px-3 py-0 border rounded-pill shadow-sm background-hover"
                        onClick={this.showHideDropdown}
                    >
                        <i className="bi bi-person-lines-fill fs-2"></i>
                    </div>
                    <Dropdown.Toggle
                        ref={this.refToToggleDropdownButton}
                        className="position-absolute top-0 end-0 invisible pb-1 m-0 border-0"
                    />
                    <Dropdown.Menu className="p-0">
                        <Dropdown.Header>{this.props.userName}</Dropdown.Header>
                        <Dropdown.Divider className="p-0 m-0" />
                        <Dropdown.Item className="dropdownItem" href="/changepassword">
                            Zmiana hasła
                        </Dropdown.Item>
                        <Dropdown.Divider className="p-0 m-0" />
                        <Dropdown.Item className="dropdownItem redi" href="/authentication/logout">
                            Wyloguj
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </nav>
        );
    }
}
